import PT from 'prop-types';
import React from 'react';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function DisabledFeatureAlert({ description = undefined, enableIcon = false }) {
  const intl = useIntl();
  const defaultDescription = intl.formatMessage({
    id: 'DisabledFeatureAlert.defaultDescription',
    defaultMessage: 'This feature is not currently enabled for your account.',
    description: 'Default message when feature is disabled',
  });

  return (
    <FlexLayout flexDirection="column">
      <FlexLayout space={2} pb={4} alignItems="center">
        {enableIcon && <Icon color="status.info" icon="status-warning" />}
        <FlexLayout flexDirection="column">
          <Text color="gray-600" variant="s-dense">
            {description ?? defaultDescription}
          </Text>
        </FlexLayout>
      </FlexLayout>
    </FlexLayout>
  );
}

DisabledFeatureAlert.propTypes = {
  description: PT.string,
  enableIcon: PT.bool,
};

export default DisabledFeatureAlert;
